import React from 'react'
import {Modal, Timeline} from '@therms/atalaya'

import {RPCDocs, UserName} from '@therms/react-modules'
import dayjs from 'dayjs'

type StatusEvent = RPCDocs.Reports.GetReport.v1.StatusHistory
type Report = RPCDocs.Reports.GetReport.v1.Report

interface Props {
  closeHandler: () => void
  report: Report
}

function ShowStatusHistoryModal({closeHandler, report}: Props) {
  const statusHistory = report.statusHistory.map((curr, index, arr) => {
    const prev = arr[index - 1]
    return {
      ...curr,
      setAtDate: dayjs(curr.setAtDate).format('dddd MMM D, YYYY h:mm A'),
      title: prev
        ? `Status changed from “${prev.title}” to "${curr.title}" by`
        : `Report created by`,
      userId: curr.userId,
    }
  })

  const renderHistoryItem = (event: StatusEvent) => (
    <div className="color-neutral mb-0 inline-flex text-base">
      {event.title}&nbsp;
      <UserName userId={event.userId} />
    </div>
  )

  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header="View Report Status History"
    >
      <div className="gap-y-lg mx-lg my-base flex flex-col">
        {statusHistory.length > 0 ? (
          <Timeline
            data={statusHistory}
            timestampExtractor={(status: StatusEvent) => status.setAtDate}
            render={renderHistoryItem}
          />
        ) : (
          <p className="color-neutral my-sm text-center text-base">
            No status history
          </p>
        )}
      </div>
    </Modal>
  )
}

export {ShowStatusHistoryModal}
